<template>
    <g id="grid-lines">
        <!-- <rect id="background-cover" width="100%" height="100%" fill="#3353ff"/> -->
        <path
            v-for="(d, i) in horizontalPaths"
            class="horizontal-lines"
            :key="`h-${d}-${i}`"
            :d="d"
            stroke="white"
            stroke-width="0.75"
        ></path>

        <path
            v-for="(d, i) in verticalPaths"
            class="vertical-lines"
            :key="`v-${d}-${i}`"
            :d="d"
            stroke="white"
            stroke-width="0.75"
        ></path>
    </g>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['w', 'h']),

        horizontalPaths() {
            return this.intervals(this.h, 100).map(
                y => `M${this.w} ${y} L${0} ${y}`
            )
        },
        verticalPaths() {
            return this.intervals(this.w, 100).map(
                x => `M${x} ${0} L${x} ${this.h}`
            )
        }
    },

    methods: {
        intervals(size, interval) {
            const ea = new Array(Math.floor(size / interval) + 1)
            return Array.from(ea, (_, i) => i * 100)
        }
    }
}
</script>

